export default function fixCornerWardrobeDepth(
  singleWardrobe,
  wardrobeType,
  depthFromApi,
  newDepth,
) {
  const wardrobeTypes = Object.values(singleWardrobe.types);
  const currentWardrobeType = wardrobeTypes[wardrobeTypes.length - 1];
  if (currentWardrobeType === wardrobeType) {
    return newDepth;
  }
  return depthFromApi;
}
